/**
 * @license
 * Copyright 2023 Ada School
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import "./unregister-sw";

import { ApolloProvider } from "@apollo/client/react";
import React, { Suspense } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router";
import { ErrorBoundary } from "./ErrorBoundary";
import { ThemeSwitcher } from "./ThemeSwitcher";
import { apolloClient } from "./apolloClient";
import i18next from "./i18n";
import "./index.css";
import { UserProvider } from "./providers/UserProvider";

const container = document.getElementById("root");
// oxlint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Suspense fallback={null}>
        <HelmetProvider>
          <BrowserRouter useTransitions={false}>
            <I18nextProvider i18n={i18next}>
              <ApolloProvider client={apolloClient}>
                <UserProvider>
                  <DndProvider backend={HTML5Backend}>
                    <ThemeSwitcher />
                  </DndProvider>
                </UserProvider>
              </ApolloProvider>
            </I18nextProvider>
          </BrowserRouter>
        </HelmetProvider>
      </Suspense>
    </ErrorBoundary>
  </React.StrictMode>
);
